var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar notranslate",style:(_vm.avatarSizeStyle)},[(!_vm.avatarPhotoUrl)?_c('div',{staticClass:"no-photo"},[_vm._v("\n    "+_vm._s(_vm.noAvatarPhotoUrl)+"\n  ")]):_c('div',{staticClass:"avatar-url",style:(_vm.avatarBgStyle)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7737e19b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Avatar.vue
// module id = null
// module chunks = 